import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  href: "/admin",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "inline-flex items-center gap-1" }
const _hoisted_4 = ["href"]

import { computed, ref, watch, onMounted, nextTick } from 'vue'
import UiBanner from '@klausapp/ui-kit/components/UiBanner.vue'
import { ExternalLinkIcon, InfoIcon } from '@klausapp/ui-kit/icons'

import { session } from '@/composables/useSession'
import { hasAccountRole } from '@/utils/roleUtils'
import analytics from '@/utils/analytics'
import { useEvent } from '@/composables/useEvent'
import useApplicationBanners from '../composables/useApplicationBanners'

const GLOBAL_NAV_BANNER_SHOWN_KEY = 'globalNavBannerShown'


export default /*@__PURE__*/_defineComponent({
  __name: 'ApplicationBanners',
  emits: ["padding-change"],
  setup(__props, { emit: __emit }) {

const emit = __emit

const getNavigationInfoVisibility = () => {
  if (!session.features.zendeskUiNavigationBanner || !hasAccountRole('ADMIN')) return false

  // Check if user has previously dismissed the banner
  const bannerDismissed = localStorage.getItem(GLOBAL_NAV_BANNER_SHOWN_KEY) === 'true'
  return !bannerDismissed
}

const root = ref<HTMLDivElement>()
const zdNavigationInfoVisible = ref(getNavigationInfoVisibility())

const {
  trialEndingVisible,
  trialRemainingCount: trialRemaining,
  trialRemainingText,
  userLimitVisible,
  zdTrialVisible,
  hideZDTrialBanner,
} = useApplicationBanners()

const bannersVisible = computed(
  () => zdTrialVisible.value || trialEndingVisible.value || userLimitVisible.value || zdNavigationInfoVisible.value,
)

watch(bannersVisible, async () => {
  await nextTick()
  setBannerPadding()
})

useEvent('user-limit-reached', () => (userLimitVisible.value = true))

onMounted(async () => {
  await nextTick()
  setBannerPadding()
})

const dismissZDTrialBanner = () => {
  hideZDTrialBanner.value = true
  analytics.closeMessageClicked()
}

const dismissUserLimitBanner = () => {
  userLimitVisible.value = false
  analytics.closeMessageClicked()
}

const dismissGlobalNavigationBanner = () => {
  localStorage.setItem(GLOBAL_NAV_BANNER_SHOWN_KEY, 'true')
  zdNavigationInfoVisible.value = getNavigationInfoVisibility()
  analytics.closeMessageClicked()
}

const setBannerPadding = () => {
  let padding = bannersVisible.value ? '45px' : '0px'

  if (document.body.clientWidth <= 768 && root.value) {
    // Get height of all banners
    const height = Array.from(root.value.children).reduce((acc, child) => {
      if ((child as HTMLElement).style.display === 'none') return acc
      return acc + (child as HTMLElement).offsetHeight
    }, 0)

    padding = height + 'px'
  }

  emit('padding-change', padding)
}

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_sanitize = _resolveDirective("sanitize")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root
  }, [
    (_unref(zdTrialVisible))
      ? (_openBlock(), _createBlock(UiBanner, {
          key: 0,
          status: "info",
          onClose: dismissZDTrialBanner
        }, {
          default: _withCtx(() => [
            _createVNode(_component_i18n_t, {
              tag: "div",
              keypath: "modules.application.banners.trial_left.template_zd_only"
            }, {
              days: _withCtx(() => [
                (_unref(hasAccountRole)('ADMIN'))
                  ? (_openBlock(), _createElementBlock("a", _hoisted_1, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('modules.application.banners.trial_left.days', _unref(trialRemaining))), 1 /* TEXT */)
                    ]))
                  : (_openBlock(), _createElementBlock("strong", _hoisted_2, _toDisplayString(_ctx.$t('modules.application.banners.trial_left.days', _unref(trialRemaining))), 1 /* TEXT */))
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    (_unref(trialEndingVisible))
      ? (_openBlock(), _createBlock(UiBanner, {
          key: 1,
          status: "info",
          stubborn: ""
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("p", null, null, 512 /* NEED_PATCH */), [
              [_directive_sanitize, _unref(trialRemainingText)]
            ])
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    (_unref(userLimitVisible))
      ? (_openBlock(), _createBlock(UiBanner, {
          key: 2,
          status: "warning",
          onClose: dismissUserLimitBanner
        }, {
          default: _withCtx(() => [
            _createVNode(_component_i18n_t, { keypath: "modules.application.banners.user_limit.template" }, {
              link: _withCtx(() => [
                _createVNode(_component_router_link, { to: { name: 'settings.subscription' } }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('modules.application.banners.user_limit.link')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    (zdNavigationInfoVisible.value)
      ? (_openBlock(), _createBlock(UiBanner, {
          key: 3,
          status: "info",
          onClose: dismissGlobalNavigationBanner
        }, {
          default: _withCtx(() => [
            _createVNode(_component_i18n_t, { keypath: "modules.application.banners.new_navigation.template" }, {
              intro: _withCtx(() => [
                _createElementVNode("span", _hoisted_3, [
                  _createVNode(_unref(InfoIcon), { class: "icon-s" }),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t('modules.application.banners.new_navigation.intro')), 1 /* TEXT */)
                ])
              ]),
              link: _withCtx(() => [
                _createElementVNode("a", {
                  href: _ctx.$t('modules.application.banners.new_navigation.url'),
                  rel: "noopener noreferrer",
                  target: "_blank"
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('modules.application.banners.new_navigation.link_button')) + " ", 1 /* TEXT */),
                  _createVNode(_unref(ExternalLinkIcon), { class: "icon-s" })
                ], 8 /* PROPS */, _hoisted_4)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ], 512 /* NEED_PATCH */))
}
}

})